<template>

  <!-- Slides Gallery Block -->
  <page-block
    bg-image-contain
    v-if="hasElements"
    :bg-file="value.file"
    :bg-color="value.bgColor"
    :width-class="widthClass"
    class="slides-gallery-block"
    :text-color="value.textColor"
    :text-align="value.textAlign"
    :overlay-class="paddingClass">

    <titled-text-element
      no-file
      no-body
      :value="value"/>

    <div
      class="ibs-mt hide-last hide-first"/>

    <slides-gallery-content
      :value="value"
      :is-fullscreen="isFullscreen"/>

  </page-block>

</template>

<script>

  import PageBlock from '@src/components/page/page-block';
  import PageBlockMixin from '@src/mixins/page-block-mixin';
  import TitledTextElement from '@src/components/element/titled-text-element';
  import SlidesGalleryContent from '@src/components/content/slides-gallery-content';

  export default {
    name: 'slides-gallery-block',
    mixins: [
      PageBlockMixin,
    ],
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
    components: {
      PageBlock,
      TitledTextElement,
      SlidesGalleryContent,
    },
    computed: {
      isFullscreen() {

        return this.widthClass === 'bmw-0'
          && this.paddingClass === 'q-pa-none';
      },
      widthClass() {

        return this.value.widthClass || 'bmw-0';
      },
      paddingClass() {

        return this.value.paddingClass || 'q-pa-none';
      },
    },
  };

</script>

<style lang="scss">

  .slides-gallery-block {
    color: inherit;
  }

</style>
